import { CascadiaColor, CascadiaMiniIcon } from "@certn/cascadia-tokens";

import { _Chip } from "../_Chip";

interface Props {
  avatar?: React.ReactNode;
  badge?: string | number;
  children: string;
  hideDropdown?: boolean;
  icon?: CascadiaMiniIcon;
  onPress?: () => void;
  isSelected?: boolean;
  isDisabled?: boolean;
  testID: string;
  textColor?: CascadiaColor;
}

export function SelectChip(props: Props) {
  const {
    icon,
    avatar,
    badge,
    hideDropdown,
    onPress,
    testID,
    children,
    isSelected,
    textColor = "text-base",
    isDisabled,
  } = props;

  return (
    <_Chip
      avatar={avatar}
      badge={badge ? String(badge) : undefined}
      icon={icon}
      isDropdown={!hideDropdown}
      onPress={() => onPress?.()}
      showBorder
      borderColor={isSelected ? "border-input-active" : "border-base"}
      testID={testID}
      textColor={textColor}
      background={
        isSelected ? "background-selected-weak-hover" : "background-base"
      }
      isDisabled={isDisabled}
    >
      {children}
    </_Chip>
  );
}
